import { EventState } from 'types/events';
import { EVENT_STATUS } from 'packages/events_repository';

export const isUpcoming = (tab: EventState) => tab === EVENT_STATUS['1'];
export const isPast = (tab: EventState) => tab === EVENT_STATUS['2'];
